import { render, staticRenderFns } from "./ProductToWithdrawRow.vue?vue&type=template&id=5c855cc5&scoped=true"
import script from "./ProductToWithdrawRow.vue?vue&type=script&lang=ts"
export * from "./ProductToWithdrawRow.vue?vue&type=script&lang=ts"
import style0 from "./ProductToWithdrawRow.vue?vue&type=style&index=0&id=5c855cc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c855cc5",
  null
  
)

export default component.exports